// ABOUTME: Applies upload context data to applicant creation initial values.
// ABOUTME: Keeps uploaded CV files attached when parser data is unavailable.

import { IApplicantNewLocalStateData } from "./useApplicantNewContext/ApplicantNewContextHelper";

export const applyApplicantUploadStateToValues = (
    valuesFromSource: Compleo.IObject,
    localStateData: IApplicantNewLocalStateData,
    fieldsToHide: string[]
) => {
    const hasUploadedCv = Boolean(localStateData?.cvFile?.streamContent);
    const hasParsedCv = Boolean(localStateData?.jsonParsedCV);

    if (localStateData?.jsonParsedCV?.TxtCV) {
        valuesFromSource.cvText = localStateData.jsonParsedCV.TxtCV;
    }

    if (hasUploadedCv) {
        valuesFromSource.cv = {
            FileInfo: localStateData.cvFile.streamContent,
            tags: []
        };
        fieldsToHide.push("cv");
    }

    if (hasUploadedCv || hasParsedCv) {
        valuesFromSource.deleted = false;
    }

    return valuesFromSource;
};

export const shouldForceManualUploadEmailField = (
    localStateData: IApplicantNewLocalStateData,
    valuesFromSource: Compleo.IObject
) =>
    localStateData?.pageToRender === "dataEntry" &&
    Boolean(localStateData?.cvFile?.streamContent) &&
    !valuesFromSource?.email;

export const forceManualUploadEmailField = (
    metadata: Compleo.IObject,
    localStateData: IApplicantNewLocalStateData,
    valuesFromSource: Compleo.IObject
) => {
    if (
        !shouldForceManualUploadEmailField(localStateData, valuesFromSource) ||
        metadata?.status !== "success" ||
        !Array.isArray(metadata?.response?.data?.metadado)
    ) {
        return metadata;
    }

    let changed = false;
    const metadado = metadata.response.data.metadado.map((field: any) => {
        if (field?.fieldName !== "email" || field?.elementType !== "label") {
            return field;
        }

        changed = true;
        return {
            ...field,
            elementType: "text"
        };
    });

    if (!changed) {
        return metadata;
    }

    return {
        ...metadata,
        response: {
            ...metadata.response,
            data: {
                ...metadata.response.data,
                metadado
            }
        }
    };
};
